<div class="user-panel">
  <div class="user-info">
    <i class="mt-2 fad fa-user-circle fa-2x"></i>
    <div class="user-name">{{userData.name}} {{userData.lastName}}</div>
  </div>
  <!-- <div class=""><small>{{companyData.companyName}}</small></div> -->
  <dx-context-menu id="topNavDropdownW" *ngIf="menuMode === 'context'" [items]="menuItems" target=".user-button"
    showEvent="dxclick" width="210px" [position]="{ my: 'top center', at: 'bottom center' }" cssClass="user-menu">
  </dx-context-menu>
  <dx-list *ngIf="menuMode === 'list'" class="dx-toolbar-menu-action" [items]="menuItems">
  </dx-list>
</div>